// ==============================|| THEME CONFIG  ||============================== //

const config = {
    defaultPath: '/',
    fontFamily: `'Public Sans', sans-serif`,
    i18n: 'en',
    miniDrawer: false,
    container: true,
    mode: 'light',
    presetColor: 'default',
    themeDirection: 'ltr',
    serverUrl: process.env.REACT_APP_SERVER_URL ?? 'http://localhost:8080',
    ttsServiceUrl: 'http://10.3.30.12:4000',
    ttsHost: 'beepbx.beevoip.it',
    ttsTestVoice: {
        it: 'it_IT-paola-medium',
        fr: 'fr_FR-siwis-medium'
    } as Record<string, string>,
    reactAppVersion: process.env.REACT_APP_VERSION
};

export default config;
export const drawerWidth = 260;

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';
